import { motion } from "framer-motion";
import { Star } from "lucide-react";

const QUOTES = [
  { n: "Ramesh G.", c: "Hyundai Creta", q: "Got 3 washes and a free AC check inside the first month. Paid for itself already.", stars: 5 },
  { n: "Priya S.",  c: "Maruti Swift",  q: "Used the wheel alignment + general service labour discount. Saved ₹2,400 in one visit.", stars: 5 },
  { n: "Arjun M.",  c: "Honda City",    q: "Genuine parts, no upselling. Care+ makes routine maintenance ridiculously cheap.", stars: 5 },
  { n: "Sneha R.",  c: "Tata Nexon",    q: "Booked over WhatsApp, redeemed coupon in 10 minutes. Will renew next year for sure.", stars: 5 },
];

export default function CPTestimonials() {
  return (
    <section data-testid="cp-testimonials" className="bg-[#FAFAFA] text-[#0A0A0A] px-5 lg:px-8 py-16 sm:py-20">
      <div className="max-w-5xl mx-auto">
        <div className="flex items-end justify-between flex-wrap gap-4 mb-8">
          <div>
            <p className="text-[11px] uppercase tracking-[0.28em] text-[#D4AF37] font-bold">What members say</p>
            <h2 className="mt-3 text-3xl sm:text-4xl font-bold tracking-tight">
              1,200+ Hyderabad car owners — already saving.
            </h2>
          </div>
          <div className="flex items-center gap-1.5 text-sm font-semibold">
            <span className="flex">{[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-[#D4AF37] text-[#D4AF37]" />)}</span>
            <span>4.8 / 5</span>
            <span className="text-[#71717A]">on Google</span>
          </div>
        </div>

        <div className="grid sm:grid-cols-2 gap-4">
          {QUOTES.map((t, i) => (
            <motion.figure
              key={i}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.06 }}
              className="bg-white border border-[#E4E4E7] rounded-sm p-5"
            >
              <div className="flex mb-2">{[...Array(t.stars)].map((_, k) => <Star key={k} className="w-3.5 h-3.5 fill-[#D4AF37] text-[#D4AF37]" />)}</div>
              <blockquote className="text-sm text-[#27272A] leading-relaxed">&ldquo;{t.q}&rdquo;</blockquote>
              <figcaption className="mt-3 text-xs text-[#71717A]">
                <strong className="text-[#0A0A0A]">{t.n}</strong> · {t.c}
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
